// Toutes les sommes sont stockées en FCFA (entier).
// Affichage : arrondi à la centaine la plus proche.

export const roundToHundred = (amount: number): number => Math.round(amount / 100) * 100

const NBSP = ' ' // espace insécable — séparateur des milliers en français

/**
 * Formate un montant en FCFA pour l'affichage.
 * @example formatCFA(1500) → "1 500 FCFA"
 * @example formatCFA(1499) → "1 500 FCFA" (arrondi à la centaine)
 */
export const formatCFA = (amount: number): string => {
  const rounded = roundToHundred(amount)
  // fr-CM utilise un espace comme séparateur de milliers
  const formatted = new Intl.NumberFormat('fr-CM', {
    useGrouping: true,
    maximumFractionDigits: 0,
  }).format(rounded)
  // Selon les versions de Node/ICU, Intl peut renvoyer U+0020, U+00A0 (NBSP) ou
  // U+202F (NNBSP). On normalise tout en NBSP pour un rendu cohérent.
  return `${formatted.replace(/\s/g, NBSP)}${NBSP}FCFA`
}

/** Parse un montant FCFA saisi par l'utilisateur ("1 500 FCFA", "1500", "1.500") en entier. */
export const parseCFA = (input: string): number => {
  const cleaned = input.replace(/[^\d-]/g, '')
  const n = Number.parseInt(cleaned, 10)
  return Number.isFinite(n) ? n : 0
}
